export const CUSTOMER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

export const PROCESSING_DATE_AND_TIME = "Processing date and time"
export const PLACE_DURING_BUSINESS_HOUR = "Place during business hour"
export const CURBSIDE_PICKUP_REQUIRED = "To continue, please select curbside pickup."
export const PAYMENT_ERROR_MESSAGE = "Something went wrong. Please try again.";
export const SNAP_ELIGIBLE_ITEMS = "Shop SNAP EBT Eligible Items";

export const ReactQueryKeys = {
  PRODUCTS_FROM_UPC: 'productsFromUpc',
  COUPON_LIST: 'couponList',
  COUPON_DETAILS: 'couponDetails',
  CUSTOMER_DETAILS: 'customerDetails',
  CUSTOMER_ADDRESS_LIST: 'customerAddressList',
  BANNER_AND_TESTIMONIALS_DATA: 'bannerAndTestimonialsData',
  STORE_DETAILS: 'storeDetails',
  STORE_LIST: 'storeList',
  CATERING_PRODUCTS: 'cateringProducts',
  CATERING_TREE: "cateringTree",
  AVAILABLE_COUPONS: 'availableCoupons',
  FUEL_CARD: 'fuelCard',
  FREQUENTLY_PURCHASED_PRODUCTS: 'frequentlyPurchasedProducts',
  LIST_DETAILS: 'listDetails',
  REWARD_POINTS_HISTORY: 'rewardPointsHistory',
}

export const Clients = {
  Redners: "323",
  Mosers: "116",
  Hardings: "317",
  PigBham: "186"
}

export const getPatternPasswordValidationMessage = (minLengh, maxLengh) => `${minLengh} - ${maxLengh} characters long. 1 Capital letter, 1 small letter, 1 Special character, 1 numeric required.`

export const AddressTypes = {
  "shipping": "shipping",
  "billing": "billing",
}

export const ReOrderTypes = {
  ecom: "Ecom",
  catering: "Catering",
  mealkit: "Mealkit",
}

export function getAvailableAmount(primaryAmount, fallbackAmount) {
  return +primaryAmount > 0 ? +primaryAmount : +fallbackAmount
}

export const NAME_PATTERN = /^[a-zA-ZÀ-ÿ'.\-\s]+$/

export const DEBUG = localStorage.getItem("DEBUG") === "1"